"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var breakpoints = _ref.breakpoints,
      palette = _ref.palette;
  return {
    root: {
      cursor: function cursor(props) {
        return props.onClick ? "pointer" : "inherit";
      },
      height: function height(props) {
        return props.height;
      },
      width: "100%"
    },
    content: {
      zIndex: 1
    },
    contentsRoot: {
      color: palette.text.primary,
      position: "relative",
      alignItems: "flex-end"
    },
    contents: _defineProperty({}, breakpoints.up("md"), {
      bottom: 0,
      color: palette.text.secondary,
      minHeight: "33%",
      padding: "1rem",
      position: "absolute",
      "&:before": {
        bottom: 0,
        background: "transparent linear-gradient(180deg, #FFFFFF 0%, #000000 60%, #000000 100%) 0% 0% no-repeat padding-box",
        content: '""',
        left: 0,
        mixBlendMode: "multiply",
        opacity: 0.5,
        position: "absolute",
        right: 0,
        top: 0
      }
    }),
    picture: {
      height: "100%",
      position: "absolute",
      width: "auto"
    },
    pictureSelected: {},
    title: {
      width: "100%"
    },
    link: {},
    name: {
      width: "100%"
    },
    nameSelected: {},
    description: {
      width: "100%"
    }
  };
});
var _default = useStyles;
exports["default"] = _default;